/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host .option,
:host .option-parent-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.1428571429rem;
}
:host .list > .option-parent:first-child > .option-parent-item,
:host .list > .option:first-child {
  margin-top: 0;
}
:host .option-parent {
  padding: 0px;
  border-left: 0px;
  background-color: rgba(255, 255, 255, 0);
}
:host .option-parent[highlighted] {
  background-color: #EEEFF0;
  background-color: var(--davinci-color-background-3, #EEEFF0);
}
:host .option-parent[highlighted] .children {
  background-color: #fff;
}
:host .option-parent-item {
  font-weight: 700;
  padding: 0 1.1428571429rem 0 0.7142857143rem;
  color: #50585C;
  color: var(--davinci-color-text-light, #50585C);
}
:host .option {
  color: #2C3133;
  color: var(--davinci-color-text-on-background-3, #2C3133);
}
:host .option:hover,
:host .option-parent-item:hover,
:host .option-parent-item.selected,
:host .option-parent.selected > .option-parent-item {
  background-color: #EEEFF0;
  background-color: var(--davinci-color-background-3, #EEEFF0);
}
:host .option-parent .option {
  padding-left: 2.2857142857rem;
}
:host .option,
:host .option > span,
:host .option-parent-item > .label,
:host > .container > div.currentvalue > span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
:host davinci-checkbox {
  margin: auto 0px;
  padding-left: 0.5714285714rem;
}`;
export { style };
